module.exports = __webpack_public_path__ + "img/CNX.38a91641.svg";